<div
  *ngIf="messages.length > 0"
  class="message-container"
  (mouseenter)="stopCarousel()"
  (mouseleave)="startCarousel()"
>
  <div
    [@changeMessageTrigger]="messageIndex === currentIndex ? 'active' : 'inactive'"
    class="message"
    *ngFor="let message of messages; let messageIndex = index"
  >
    <div class="details">
      <p class="title">{{ message.title }}</p>
      <div class="description">
        <p>{{ message.message }}</p>
      </div>
      <div>
        <button class="td-btn call-to-action" (click)="openLink(message.urlCallToAction)">
          Conocer más
        </button>
      </div>
    </div>
    <div class="image disappear-mobile disappear-medium-desktop">
      <img [src]="message.imageUrl" alt="Imágen de la promoción" />
    </div>
    <div *ngIf="currentIndex === messageIndex" class="close" (click)="closeBanner(messageIndex)">
      <img src="assets/icons/news/close.svg" alt="close banner" />
    </div>
  </div>
  <div *ngIf="messages.length > 1" class="dots">
    <span
      *ngFor="let message of messages; let messageIndex = index"
      class="dot"
      [ngClass]="{ active: messageIndex === currentIndex }"
      (click)="changeIndex(messageIndex)"
    >
    </span>
  </div>
</div>
